import { Component, Input, OnInit, ViewChild, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CerrixEditorComponent } from "@app/shared/components/cerrix-editor/cerrix-editor.component";
import { ModuleType } from "@enums/ModuleType";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { TranslocoService } from "@jsverse/transloco";
import { ToastrService } from "ngx-toastr";
import { firstValueFrom } from "rxjs";

@Component({
    selector: "uc-periodic-notification-detail",
    templateUrl: "./periodic-notification-detail.component.html",
    styleUrls: ["./periodic-notification-detail.component.scss"],
    standalone: false
})
export class PeriodicNotificationDetailComponent implements OnInit {
    private _route = inject(ActivatedRoute);
    private toastr = inject(ToastrService);
    private transloco = inject(TranslocoService);

    @ViewChild("editor") editorComponent: CerrixEditorComponent;
    module: ModuleType;
    moduleTypes = ModuleType;

    tab: TabModel;
    id: any;

    constructor() {
        this.id = this._route.snapshot.params.id;
    }

    async ngOnInit() {
        // A pipe/directive on this component's own template triggers the scope load, but the
        // @switch below renders no sub-component (and so no pipe) until `module` is set, so an
        // early return here must preload the scope itself before translating.
        await firstValueFrom(this.transloco.load(`mailmessages/${this.transloco.getActiveLang()}`));

        const config = this.tab.config;
        if (!config) {
            this.toastr.error(this.transloco.translate("mailmessages.periodicDetail.errorOpeningDetails"));
            this.tab.close(false);
            return;
        }

        this.module = config.module;
    }
}
